import { configFetch as fetch } from '@meiqia/utils';

export const getEnterPriseIframeConfigApi = () => {
  return fetch({
    url: `/enterprise/iframes`,
    method: 'get'
  });
};

export const getEnterPriseIframeEncryptConfigApi = () => {
  return fetch({
    url: `/unified-api/team/v1/enterprise/iframe_encrypt_config`,
    method: 'get'
  });
};

export const updateIframeEncryptStatus = enable => {
  return fetch({
    url: '/unified-api/team/v1/enterprise/iframe_encrypt_config/enabled',
    method: 'put',
    data: {
      enable: enable
    }
  });
};

export const getEnterPriseIframeEncryptedInfoApi = value => {
  return fetch({
    url: `/unified-api/team/v1/enterprise/iframes/encrypt`,
    method: 'post',
    params: {
      value: value
    }
  });
};
